import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
const FilterDropdown = ({ id, label, selectedValue, placeholder, options, onSelect }) => {
    var _a, _b;
    const [isOpen, setIsOpen] = useState(false);
    const rootRef = useRef(null);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const selected = options.find(o => o.value === selectedValue);
    const displayValue = (_b = (_a = selected === null || selected === void 0 ? void 0 : selected.label) !== null && _a !== void 0 ? _a : placeholder) !== null && _b !== void 0 ? _b : 'Select…';
    // Close when clicking outside the dropdown
    useEffect(() => {
        if (!isOpen)
            return;
        const handleMouseDown = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleMouseDown);
        return () => document.removeEventListener('mousedown', handleMouseDown);
    }, [isOpen]);
    // Move focus into the menu when it opens (selected option, else first)
    useEffect(() => {
        var _a;
        if (isOpen && menuRef.current) {
            const target = (_a = menuRef.current.querySelector('button.active')) !== null && _a !== void 0 ? _a : menuRef.current.querySelector('button');
            target === null || target === void 0 ? void 0 : target.focus();
        }
    }, [isOpen]);
    const close = () => {
        var _a;
        setIsOpen(false);
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const handleSelect = (value) => {
        onSelect(value);
        close();
    };
    const handleButtonKeyDown = (e) => {
        if (e.key === 'ArrowDown' && !isOpen) {
            e.preventDefault();
            setIsOpen(true);
        }
        else if (e.key === 'Escape' && isOpen) {
            e.preventDefault();
            close();
        }
    };
    const handleMenuKeyDown = (e) => {
        var _a, _b, _c, _d;
        const items = Array.from((_b = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('button')) !== null && _b !== void 0 ? _b : []);
        const currentIndex = items.findIndex(item => item === document.activeElement);
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                (_c = items[(currentIndex + 1) % items.length]) === null || _c === void 0 ? void 0 : _c.focus();
                break;
            case 'ArrowUp':
                e.preventDefault();
                (_d = items[(currentIndex - 1 + items.length) % items.length]) === null || _d === void 0 ? void 0 : _d.focus();
                break;
            case 'Escape':
                e.preventDefault();
                close();
                break;
            case 'Tab':
                setIsOpen(false); // let focus move on naturally
                break;
        }
    };
    return (_jsxs("div", { className: "mapdashboard-toolbar-dd", ref: rootRef, children: [_jsxs("button", { ref: buttonRef, id: `${id}-btn`, className: "mapdashboard-toolbar-dd-btn", type: "button", "aria-haspopup": "listbox", "aria-expanded": isOpen, "aria-controls": `${id}-menu`, onClick: () => setIsOpen(prev => !prev), onKeyDown: handleButtonKeyDown, children: [_jsx("span", { className: "lbl", children: label }), ' ', _jsx("span", { className: "val", children: displayValue }), ' ', _jsx("i", { className: "bi bi-chevron-down", "aria-hidden": "true" })] }), _jsx("div", { ref: menuRef, id: `${id}-menu`, className: `mapdashboard-toolbar-dd-menu${isOpen ? ' open' : ''}`, role: "listbox", "aria-labelledby": `${id}-btn`, onKeyDown: handleMenuKeyDown, children: options.map(option => (_jsx("button", { type: "button", role: "option", "aria-selected": option.value === selectedValue, className: option.value === selectedValue ? 'active' : '', onClick: () => handleSelect(option.value), children: option.label }, option.value))) })] }));
};
export default FilterDropdown;
